import React from "react";

import { mdiContentSave } from "@mdi/js";
import Icon from "@mdi/react";
import { useTranslation } from "react-i18next";

import Button from "../button/Button";

import type { JSX } from "react";

interface SaveButtonProps {
  formId: string;
}

export default function SaveButton({ formId }: SaveButtonProps): JSX.Element {
  const { t } = useTranslation("common");

  return (
    <Button form={formId} size="md" type="submit">
      <Icon path={mdiContentSave} size={0.9375} />
      {t("save", { ns: "common" })}
    </Button>
  );
}
